import styled from "@emotion/styled";

export const Container = styled.div`
  inline-size: 240px;

  color: #ffffff;
  font-size: 16px;
  line-height: 18px;

  a {
    color: #ffffff;
    text-decoration: underline;
  }
`;
